import {ResourceParams} from "../resources";

export type OthersResourceType =
  'utm' |
  'manager-info' |
  'contact-info' |
  'audiences' |
  'oz-sale-info' |
  'sale-info-day' |
  'approve' |
  'blogger-archive-material-types' |
  'product-cards-daily-ratings';

export const othersResources: {
  [key in OthersResourceType]: ResourceParams
} = {
  'utm': {
    key: 'utm',
    name: 'UTM',
    path: 'utm'
  },
  'manager-info': {
    key: 'manager-info',
    name: '',
    path: 'manager-info'
  },
  'contact-info': {
    key: 'contact-info',
    name: '',
    path: 'contact-info'
  },
  'audiences': {
    key: 'audiences',
    name: '',
    path: 'audiences'
  },
  'oz-sale-info': {
    key: 'oz-sale-info',
    name: 'Продажи Ozon',
    path: 'oz-sale-info'
  },
  'sale-info-day': {
    key: 'sale-info-day',
    name: 'Продажи Wildberries',
    path: 'sale-info-day'
  },
  'approve': {
    key: 'approve',
    name: 'Статус подтверждения',
    path: 'approve'
  },
  'blogger-archive-material-types': {
    key: 'blogger-archive-material-types',
    name: 'Вид материалов',
    path: 'blogger-archive-material-types'
  },
  'product-cards-daily-ratings': {
    key: 'product-cards-daily-ratings',
    name: '',
    path: 'product-cards-daily-ratings'
  }
};
